// deps
import PropTypes from "prop-types";
import { Box } from "@chakra-ui/react";
import useCoversFile from "../../../hooks/covers/useFile";

/**
 * @param {import("@chakra-ui/react").BoxProps & {
 * coverImage: any,
 * width: number,
 * height: number,
 * x: number,
 * y: number,
 * cropWidth: number,
 * cropHeight: number,
 * }} props
 */
export default function CoversPreview(props) {
  const {
    coverImage,
    width,
    height,
    x,
    y,
    cropWidth,
    cropHeight,
    ...otherProps
  } = props;

  const ratio = width / cropWidth;

  const file = useCoversFile(coverImage);

  return (
    <Box w={`${width}px`} h={`${height}px`} {...otherProps} overflow="hidden">
      <Box
        transformOrigin="top left"
        transform={`scale(${ratio})`}
        bgImage={`url(${file})`}
        bgPos={`${-x}px ${-y}px`}
        bgRepeat="no-repeat"
        w={`${cropWidth}px`}
        h={`${cropHeight}px`}
      />
    </Box>
  );
}

CoversPreview.propTypes = {
  coverImage: PropTypes.any,
  width: PropTypes.number,
  height: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
  cropWidth: PropTypes.number,
  cropHeight: PropTypes.number,
};
